import { render, staticRenderFns } from "./goodsdetail.vue?vue&type=template&id=2cd2ccce&scoped=true&"
import script from "./goodsdetail.vue?vue&type=script&lang=js&"
export * from "./goodsdetail.vue?vue&type=script&lang=js&"
import style0 from "./goodsdetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./goodsdetail.vue?vue&type=style&index=1&id=2cd2ccce&leng=less&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd2ccce",
  null
  
)

export default component.exports